var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_24197",
    "data-name": "Group 24197",
    transform: "translate(-1380 -78)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24196",
    "data-name": "Group 24196",
    transform: "translate(1283.221 -143.778)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 7,
    cy: 7,
    r: 7,
    transform: "translate(98.778 223.778)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M114.018,239.485l4,4",
    transform: "translate(-2.941 -3.062)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8527",
    "data-name": "Rectangle 8527",
    width: 20,
    height: 20,
    transform: "translate(1380 78)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search_icon.cb7d15d2.svg";
export { ForwardRef as ReactComponent };